import React from "react";
// @ts-ignore
import callIcon from "../../images/footer/contact/call.svg";
// @ts-ignore
import mailIcon from "../../images/footer/contact/mail.svg";
// @ts-ignore
import locationIcon from "../../images/footer/contact/location.svg";
// @ts-ignore
import whatsappIcon from "../../images/footer/contact/whatsapp.svg";
import FooterBlockType from "../../types/footerBlock.type";
import MaxWidthWrapper from "../common/MaxWidthWrapper";
import SecondaryWidthWrapper from "../common/SecondaryWidthWrapper";
import FacebookIconSvg from "../svg/FacebookIcon.svg";
import InstagramIconSvg from "../svg/InstagramIcon.svg";
import TwitterIconSvg from "../svg/TwitterIcon.svg";
import YoutubeIconSvg from "../svg/YoutubeIcon.svg";
// @ts-ignore
import clutchLogo from "../../../static/img/clutch-logo.png";
// @ts-ignore
import upWorkLogo from "../../../static/img/upWork-logo.png";

import { Link } from "gatsby";
import LinkedinSvg from "../svg/linkedin.svg";
import UpWork from "../svg/UpWork.svg";
import Slugs from "../../util/slugs";

const Footer: React.FC<FooterBlockType> = ({ data, meta }) => {
  const currentYear = new Date().getFullYear();
  const copyRight = `©${currentYear} by Propelius Technologies.`;
  const companyLocation =
    "https://www.google.co.in/maps/place/Propelius+Technologies/@21.1531509,72.7783776,19.31z/data=!4m5!3m4!1s0x3be04de5c0000001:0xc5224f558e0ee498!8m2!3d21.152971!4d72.7788452?hl=en-GB&authuser=0";

  return (
    <div className={"pb-[20px] lg:block xl:pt-[98px]"}>
      <div>
        <hr className={"bg-primary p-[1px] xl:p-1 "} />
      </div>
      <MaxWidthWrapper>
        <SecondaryWidthWrapper>
          <div
            className={
              "pt-[37px] pb-[70px] xl:m-auto xl:px-0 xl:pt-[112px] xl:pb-[142px]"
            }
          >
            <div
              className={
                "flex flex-col gap-y-[40px] gap-x-[4rem] xl:m-auto xl:flex xl:max-w-[1600px] xl:flex-row xl:justify-between"
              }
            >
              <div
                className={
                  "flex flex-col gap-y-[40px] md:flex-row md:justify-between xl:flex-col xl:justify-center"
                }
              >
                <div
                  className={
                    "flex items-center gap-x-[42px] xl:flex xl:flex-col xl:gap-y-[33px]"
                  }
                >
                  <div>
                    <Link to={"/"}>
                      <img
                        className={
                          "w-[142px] md:w-[180px] lg:w-[210px] xl:w-[259px]"
                        }
                        src={`${data?.attributes?.companyTitle?.companyLogo?.data?.attributes?.url}`}
                        alt={"Company logo"}
                      />
                    </Link>
                  </div>
                  <div
                    className={
                      "flex gap-x-[16px] xl:flex xl:flex-wrap xl:items-center xl:justify-start xl:gap-x-[24px]"
                    }
                  >
                    {data?.attributes?.companyTitle?.socialMedia?.linkedIn && (
                      <div>
                        <a
                          href={`${data?.attributes?.companyTitle?.socialMedia?.linkedIn}`}
                          target="_blank"
                        >
                          <div className={"hidden xl:block"}>
                            <LinkedinSvg smallWidth={false} />
                          </div>
                          <div className={"block xl:hidden"}>
                            <LinkedinSvg smallWidth={true} />
                          </div>
                        </a>
                      </div>
                    )}
                    {data?.attributes?.companyTitle?.socialMedia?.facebook && (
                      <div>
                        <a
                          href={`${data?.attributes?.companyTitle?.socialMedia?.facebook}`}
                          target="_blank"
                        >
                          <div className={"hidden xl:block"}>
                            <FacebookIconSvg smallWidth={false} />
                          </div>
                          <div className={"block xl:hidden"}>
                            <FacebookIconSvg smallWidth={true} />
                          </div>
                        </a>
                      </div>
                    )}
                    {data?.attributes?.companyTitle?.socialMedia?.instagram && (
                      <div>
                        <a
                          href={`${data?.attributes?.companyTitle?.socialMedia?.instagram}`}
                          target="_blank"
                        >
                          <div className={"hidden xl:block"}>
                            <InstagramIconSvg smallWidth={false} />
                          </div>
                          <div className={"block xl:hidden"}>
                            <InstagramIconSvg smallWidth={true} />
                          </div>
                        </a>
                      </div>
                    )}
                    {data?.attributes?.companyTitle?.socialMedia?.clutch && (
                      <div>
                        <a
                          href={`${data?.attributes?.companyTitle?.socialMedia?.clutch}`}
                          target="_blank"
                        >
                          <div className={"hidden xl:block"}>
                            <a
                              href={`${data?.attributes?.companyTitle?.socialMedia?.clutch}`}
                              target={"_blank"}
                            >
                              <img
                                src={clutchLogo}
                                alt={"clutch logo"}
                                className=" h-[25px] w-[25px] object-cover object-center md:h-[30px] md:w-[30px] lg:h-[35px] lg:w-[35px] xl:h-[43px] xl:w-[43px]"
                              />
                            </a>
                          </div>
                          <div className={"block xl:hidden"}>
                            <img
                              src={clutchLogo}
                              alt={"clutch logo"}
                              className=" h-[25px] w-[25px] object-cover object-center md:h-[30px] md:w-[30px] lg:h-[35px] lg:w-[35px] xl:h-[43px] xl:w-[43px]"
                            />
                          </div>
                        </a>
                      </div>
                    )}
                    {data?.attributes?.companyTitle?.socialMedia?.upWork && (
                      <div>
                        <a
                          href={`${data?.attributes?.companyTitle?.socialMedia?.upWork}`}
                          target="_blank"
                        >
                          <div className={"hidden xl:block"}>
                            <UpWork />
                          </div>
                          <div className={"block xl:hidden"}>
                            <UpWork />
                          </div>
                        </a>
                      </div>
                    )}
                    {data?.attributes?.companyTitle?.socialMedia?.twitter && (
                      <div>
                        <a
                          href={`${data?.attributes?.companyTitle?.socialMedia?.twitter}`}
                          target="_blank"
                        >
                          <div className={"hidden xl:block"}>
                            <TwitterIconSvg smallWidth={false} />
                          </div>
                          <div className={"block xl:hidden"}>
                            <TwitterIconSvg smallWidth={true} />
                          </div>
                        </a>
                      </div>
                    )}
                    {data?.attributes?.companyTitle?.socialMedia?.youtube && (
                      <div>
                        <a
                          href={`${data?.attributes?.companyTitle?.socialMedia?.youtube}`}
                          target="_blank"
                        >
                          <div className={"hidden xl:block"}>
                            <YoutubeIconSvg smallWidth={false} />
                          </div>
                          <div className={"block xl:hidden"}>
                            <YoutubeIconSvg smallWidth={true} />
                          </div>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/*<div style={{ display: "flex", gap: "20px" }} className={'flex gap-x-[20px]'}>*/}
              <div
                className={
                  "flex flex-col gap-y-5 md:flex-row xl:flex xl:gap-x-0 "
                }
              >
                {/*support section*/}
                <div
                  style={{ flex: 1 }}
                  className={
                    "flex flex-col gap-y-[15px] md:flex md:flex-1 md:flex-col md:gap-y-[45px] xl:flex xl:flex-col xl:gap-y-[45px]"
                  }
                >
                  <div>
                    <h4
                      className={
                        "text-sm font-medium text-[#161A27] md:text-[24px] xl:text-[24px]"
                      }
                    >
                      {data?.attributes?.supportComponent?.title}
                    </h4>
                  </div>
                  <div className={"flex gap-x-20"}>
                    <div
                      className={
                        "flex flex-col gap-y-4 text-[14px] font-medium text-secondary md:flex md:flex-col md:gap-y-[45px] md:text-[18px] md:font-normal xl:flex xl:flex-col xl:gap-y-[45px] xl:text-[18px] xl:font-normal"
                      }
                    >
                      {data?.attributes?.supportComponent?.pages?.data?.map(
                        (page, index) =>
                          page.attributes.url === "/join-us" ? (
                            <a key={index} href={page?.attributes?.url}>
                              {page?.attributes?.name}
                              <sup
                                className={
                                  "hidden text-[12px] xl:ml-[6px] xl:inline xl:rounded-[23px] xl:bg-tertiary xl:py-[3px] xl:px-[8px] xl:text-white"
                                }
                              >
                                {
                                  data?.attributes?.supportComponent
                                    ?.hiringTitle
                                }
                              </sup>
                            </a>
                          ) : (
                            <a key={index} href={page?.attributes?.url}>
                              {page?.attributes?.name}
                            </a>
                          )
                      )}
                      {/* Privacy Policy link */}
                      <Link
                        to="/privacy-policy"
                        className="text-[14px] font-medium text-secondary md:text-[18px] md:font-normal xl:text-[18px] xl:font-normal"
                      >
                        Privacy Policy
                      </Link>
                      {/* Refund Policy link */}
                      <Link
                        to="/refund-policy"
                        className="text-[14px] font-medium text-secondary md:text-[18px] md:font-normal xl:text-[18px] xl:font-normal"
                      >
                        Refund Policy
                      </Link>
                      {/* Terms and Conditions link */}
                      <Link
                        to="/terms-and-conditions"
                        className="text-[14px] font-medium text-secondary md:text-[18px] md:font-normal xl:text-[18px] xl:font-normal"
                      >
                        Terms & Conditions
                      </Link>
                      {/* Blogs link */}
                      <Link
                        to={`/${Slugs.page.BLOG_PAGE}`}
                        className="text-[14px] font-medium text-secondary md:text-[18px] md:font-normal xl:text-[18px] xl:font-normal"
                      >
                        Blogs
                      </Link>
                    </div>
                  </div>
                </div>

                {/*desktop view*/}
                <div className="hidden flex-1 flex-col space-y-8 md:flex">
                  <h4 className="text-xl font-semibold text-[#161A27]">
                    {data?.attributes?.connectUsComponent?.title}
                  </h4>
                  <div className="grid grid-cols-1 gap-4">
                    {/* HR */}
                    <div className="flex items-center">
                      <img src={callIcon} alt="Call" className="mr-3 h-6 w-6" />
                      <div>
                        <p className="text-sm text-secondary">HR</p>
                        <a
                          href={`tel:${data?.attributes?.connectUsComponent?.phoneData?.text}`}
                          className="block text-base font-medium text-secondary transition hover:text-primary"
                        >
                          {
                            data?.attributes?.connectUsComponent?.phoneData
                              ?.text
                          }
                        </a>
                      </div>
                    </div>
                    {/* Sales */}
                    <div className="flex items-center">
                      <img src={callIcon} alt="Call" className="mr-3 h-6 w-6" />
                      <div>
                        <p className="text-sm text-secondary">Sales</p>
                        <a
                          href={`tel:${data?.attributes?.connectUsComponent?.phoneData?.url}`}
                          className="block text-base font-medium text-secondary transition hover:text-primary"
                        >
                          {data?.attributes?.connectUsComponent?.phoneData?.url}
                        </a>
                      </div>
                    </div>
                    {/* Email */}
                    <div className="flex items-center">
                      <img
                        src={mailIcon}
                        alt="Email"
                        className="mr-3 h-6 w-6"
                      />
                      <div>
                        <p className="text-sm text-secondary">Email</p>
                        <a
                          href={`mailto:${data?.attributes?.connectUsComponent?.mailData?.text}`}
                          className="block text-base font-medium text-secondary transition hover:text-primary"
                        >
                          {data?.attributes?.connectUsComponent?.mailData?.text}
                        </a>
                      </div>
                    </div>
                    {/* WhatsApp */}
                    <div className="flex items-center">
                      <img
                        src={whatsappIcon}
                        alt="WhatsApp"
                        className="mr-3 h-6 w-6"
                      />
                      <div>
                        <p className="text-sm text-secondary">
                          WhatsApp{" "}
                          <span className="font-medium">
                            (Business inquiries only)
                          </span>
                        </p>
                        <a
                          href={`https://wa.me/919023550069`}
                          className="block text-base font-medium text-secondary transition hover:text-primary"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          +91 90235 50069
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Find Us */}
                <div className="hidden flex-1 flex-col space-y-8 md:flex">
                  <h4 className="text-xl font-semibold text-[#161A27]">
                    {data?.attributes?.findUsComponent?.title}
                  </h4>
                  <div className="flex items-start">
                    <img
                      src={locationIcon}
                      alt="Location"
                      className="mr-3 h-6 w-6"
                    />
                    <a
                      href={companyLocation}
                      className="text-base font-medium text-secondary transition hover:text-primary"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {data?.attributes?.findUsComponent?.addressData?.text}
                    </a>
                  </div>
                </div>

                {/*mobile view*/}
                {/*connect and find us section*/}
                <div
                  className={
                    "block flex flex-col gap-y-[27px] md:hidden xl:flex xl:hidden xl:flex-row"
                  }
                >
                  {/*connect us section*/}
                  <div
                    className={
                      "flex flex-col gap-y-[15px] text-[14px] xl:flex xl:flex-1 xl:flex-col xl:gap-y-[45px]"
                    }
                  >
                    <h4 className={"font-medium text-[#161A27] xl:text-[24px]"}>
                      {data?.attributes?.connectUsComponent?.title}
                    </h4>
                    <div
                      className={
                        "flex flex-col gap-y-[14px] font-medium text-secondary xl:flex xl:flex-col xl:gap-y-[45px] xl:text-[18px] xl:font-normal"
                      }
                    >
                      <div
                        className={
                          "flex items-center gap-x-[15px] xl:flex xl:gap-x-[16px]"
                        }
                      >
                        <div>
                          {/*<PhoneIcon />*/}
                          <img
                            className={"w-[13px] xl:w-[25px]"}
                            src={callIcon}
                            alt={"call icon"}
                          />
                        </div>
                        <div className={"flex flex-col"}>
                          {" "}
                          <a
                            href={`tel:${data?.attributes?.connectUsComponent?.phoneData?.text}`}
                            target={"_blank"}
                          >
                            <span>
                              HR &nbsp;:&nbsp;
                              {
                                data?.attributes?.connectUsComponent?.phoneData
                                  ?.text
                              }
                            </span>
                          </a>
                          <a
                            href={`tel:${data?.attributes?.connectUsComponent?.phoneData?.url}`}
                            target={"_blank"}
                          >
                            <span>
                              Sales &nbsp;:&nbsp;
                              {
                                data?.attributes?.connectUsComponent?.phoneData
                                  ?.url
                              }
                            </span>
                          </a>{" "}
                        </div>
                      </div>
                      <div
                        className={
                          "flex items-center gap-x-[15px] xl:flex xl:gap-x-[16px]"
                        }
                      >
                        <div>
                          {/*<MailIcon />*/}
                          <img
                            className={"w-[13px] xl:w-[25px]"}
                            src={mailIcon}
                            alt={"mail icon"}
                          />
                        </div>
                        <div>
                          <a
                            href={`mailto:${data?.attributes?.connectUsComponent?.mailData?.text}`}
                          >
                            {
                              data?.attributes?.connectUsComponent?.mailData
                                ?.text
                            }
                          </a>
                        </div>
                      </div>

                      {/* WHATSAPP  */}
                      <div
                        className={
                          "flex items-center gap-x-[15px] xl:flex xl:gap-x-[16px]"
                        }
                      >
                        <div>
                          {/*<MailIcon />*/}
                          <img
                            className={"w-[13px] xl:w-[25px]"}
                            src={whatsappIcon}
                            alt={"whatsapp icon"}
                          />
                        </div>
                        <div>
                          <a
                            href={`https://wa.me/919023550069`}
                            target="_blank"
                          >
                            +91 90235 50069
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*find us section*/}
                  <div
                    className={
                      "flex flex-col gap-y-[15px] text-[14px] font-medium xl:flex xl:flex-1 xl:flex-col xl:gap-y-[45px]"
                    }
                  >
                    <h4
                      className={"text-[#161A27] xl:text-[24px] xl:font-medium"}
                    >
                      {data.attributes.findUsComponent.title}
                    </h4>
                    <div
                      className={
                        "text-secondary xl:flex xl:flex-col xl:gap-y-[45px]"
                      }
                    >
                      <div
                        className={
                          "flex items-start gap-x-[15px] xl:flex xl:gap-x-[16px] xl:text-[18px] xl:font-normal"
                        }
                      >
                        <div className={"x:w-[30%] w-[6%]"}>
                          {/*<LocationIcon />*/}
                          <img
                            className={"w-[13px] xl:w-[25px]"}
                            src={locationIcon}
                            alt={"location icon"}
                          />
                        </div>
                        <div className={" w-[80%] xl:w-[80%]"}>
                          <p>
                            <a href={companyLocation} target={"_blank"}>
                              {data.attributes.findUsComponent.addressData.text}
                            </a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className={
              "flex items-center justify-center md:p-[20px] xl:p-[22px]"
            }
          >
            <p
              className={
                "text-[14px] text-[#7F7F7F] md:text-[16px] xl:text-[18px]"
              }
            >
              {copyRight}
            </p>
          </div>
        </SecondaryWidthWrapper>
      </MaxWidthWrapper>
    </div>
  );
};
export default Footer;
